// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

export default [
    "pdf",
    "csv",
    "doc",
    "docx",
    "odt",
    "rtf",
    "txt",
    "jpg",
    "jpeg",
    "png",
    "tif",
    "tiff",
    "ppt",
    "pptx",
    "wpd",
    "xls",
    "xlsx",
    "csv",
    "ods",
    "dwg"
];